export const Types = {
    LOGIN: 'LOGIN',
    REGISTER: 'REGISTER',
}